<template>
  <main role="main" class="main historyPage">
    <div class="msum-pageKv">
      <div class="msum-pageKv__inner"></div>
    </div>
    <div class="product">
      <div class="msum-pageYear" v-if="item">
        <p class="msum-pageYear__title">{{ item.west_cal }}</p>
        <p class="msum-pageYear__title2">{{ item.jp_cal }}</p>
      </div>

      <div class="msum-pageConts">
        <div class="msum-pageConts__inner">
          <not-found v-if="notFound" />
          <article class="msum-pageArticle" v-else>
            <header class="msum-pageArticle__header">
              <h1 class="msum-pageArticle__title">{{ item.title }}</h1>
              <p class="msum-pageArticle__sTitle">{{ item.heading }}</p>
            </header>

            <div
              class="msum-pageArticle__img"
              v-if="item.img_entry_path1 || item.img_entry_path2 || item.img_entry_path3"
            >
              <template v-if="item.img_entry_path1">
                <div class="msum-movBox" v-if="item.img_entry_path1.indexOf('youtu') !== -1">
                  <iframe
                    width="560"
                    height="315"
                    :src="item.img_entry_path1"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                  <span class="caption">{{ item.img_entry_caption1 }}</span>
                </div>
                <div v-else>
                  <img :src="base_url +'img/' + item.img_entry_path1" alt />
                  <span class="caption">{{ item.img_entry_caption1 }}</span>
                </div>
              </template>
              <template v-if="item.img_entry_path2">
                <div class="msum-movBox" v-if="item.img_entry_path2.indexOf('youtu') !== -1">
                  <iframe
                    width="560"
                    height="315"
                    :src="item.img_entry_path2"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                  <span class="caption">{{ item.img_entry_caption2 }}</span>
                </div>
                <div v-else>
                  <img :src="base_url +'img/' + item.img_entry_path2" alt />
                  <span class="caption">{{ item.img_entry_caption2 }}</span>
                </div>
              </template>
              <template v-if="item.img_entry_path3">
                <div class="msum-movBox" v-if="item.img_entry_path3.indexOf('youtu') !== -1">
                  <iframe
                    width="560"
                    height="315"
                    :src="item.img_entry_path3"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                  <span class="caption">{{ item.img_entry_caption3 }}</span>
                </div>
                <div v-else>
                  <img :src="base_url +'img/' + item.img_entry_path3" alt />
                  <span class="caption">{{ item.img_entry_caption3 }}</span>
                </div>
              </template>
            </div>

            <div class="msum-pageArticle__txtBox">
              <p class="msum-pageArticle__txt" v-html="item.body"></p>
            </div>
            <p class="msum-pageArticle__link" v-if="item.related_url1">
              <a :href="item.related_url1" target="_blank">{{ item.related_url_text1 }}</a>
            </p>
            <p class="msum-pageArticle__link" v-if="item.related_url2">
              <a :href="item.related_url2" target="_blank">{{ item.related_url_text2 }}</a>
            </p>
            <p class="msum-pageArticle__banner" v-if="item.img_banner_path1">
              <a :href="item.img_banner_url1" target="_blank">
                <img :src="base_url +'img/' + item.img_banner_path1" alt />
              </a>
            </p>
          </article>
        </div>
      </div>

      <div class="msum-pageNav" v-if="item">
        <div class="msum-pageNav__inner">
          <ul class="msum-pageNav__items">
            <template v-if="item.flg_list_show">
              <li class="msum-pageNav__item msum-pageNav__item--prev" v-if="prevNo">
                <router-link :to="`/product/${prevNo}`">前へ</router-link>
              </li>
              <li class="msum-pageNav__item msum-pageNav__item--next" v-if="nextNo">
                <router-link :to="`/product/${nextNo}`">次へ</router-link>
              </li>
              <li class="msum-pageNav__item msum-pageNav__item--back">
                <router-link :to="`${topLink}`">トップに戻る</router-link>
              </li>
            </template>
            <template v-else>
              <li class="msum-pageNav__item msum-pageNav__item--back">
                <a href="javascript:;" v-on:click="getBackLink">戻る</a>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import NotFound from "@/views/ProductNotFound";
import products from "@/api/products.js";
export default {
  props: { no: Number },
  data() {
    return {
      base_url: process.env.ASSET_BASE_PATH,
      notFound: false,

      nextNo: null,
      prevNo: null,
      item: null,
      cat_era_list: [
        { id: 1, name: "明治" },
        { id: 2, name: "大正" },
        { id: 3, name: "昭和初期" },
        { id: 4, name: "昭和中期" },
        { id: 5, name: "昭和後期" },
        { id: 6, name: "平成" },
        { id: 7, name: "令和" }
      ],
      cat_product_list: [
        { id: 1, name: "チョコレート" },
        { id: 2, name: "キャラメル・キャンディ" },
        { id: 3, name: "ビスケット・スナック" },
        { id: 4, name: "食品" },
        { id: 5, name: "アイス" },
        { id: 6, name: "健康" },
        { id: 7, name: "その他の商品" }
      ],
      cat_entry_list: [
        { id: 1, name: "宣伝広告" },
        { id: 2, name: "森永エピソード" }
      ],
      topLink: "/"
    };
  },
  components: {
    "not-found": NotFound
  },
  created: function() {
    const self = this;

    this.topLink = this.getTopLink();

    this.$store.watch(
      function(state, getters) {
        return state.entryList; // 監視したいデータを返す
      },
      function(newVal, oldVal) {
        const currentEntry = self.$store.getters.currentEntry;
        if (currentEntry.entry) {
          self.notFound = false;
          self.prevNo = currentEntry.prevNo;
          self.nextNo = currentEntry.nextNo;
          self.item = currentEntry.entry;
          console.log(self.item);
        } else {
          self.notFound = true;
        }
      }
    );
  },
  mounted: function() {
    const self = this;

    this.$nextTick(() => {
      scrollTo(0, 0);
    });
  },
  watch: {
    no: {
      handler(val) {
        const self = this;

        this.$store.dispatch("setCurrentId", val);

        const currentEntry = this.$store.getters.currentEntry;
        if (currentEntry.entry) {
          self.notFound = false;
          self.prevNo = currentEntry.prevNo;
          self.nextNo = currentEntry.nextNo;
          self.item = currentEntry.entry;
        } else {
          self.notFound = true;
        }
      },
      immediate: true
    }
  },
  methods: {
    getBackLink: function(event) {
      var ref = document.referrer;

      if(ref.indexOf(document.domain) !== -1){
        history.back();
      }else{
        location.href=this.$router.options.base;
      }

      return;
    },
    getTopLink: function() {
      var prev_cat_era = this.$store.getters.catEra;
      var prev_cat_product = this.$store.getters.catProduct;
      var prev_cat_entry = this.$store.getters.catEntry;

      console.log(prev_cat_era);
      console.log(prev_cat_product);
      console.log(prev_cat_entry);

      var era = this.cat_era_list.find(item => {
        return item.name == prev_cat_era;
      });
      var product = this.cat_product_list.find(item => {
        return item.name == prev_cat_product;
      });
      var category = this.cat_entry_list.find(item => {
        return item.name == prev_cat_entry;
      });

      var top_link = "/";
      if (era) {
        if (top_link == "/") {
          top_link += "?e=" + era.id;
        } else {
          top_link += "&e=" + era.id;
        }
      }
      if (product) {
        if (top_link == "/") {
          top_link += "?p=" + product.id;
        } else {
          top_link += "&p=" + product.id;
        }
      }
      if (category) {
        if (top_link == "/") {
          top_link += "?c=" + category.id;
        } else {
          top_link += "&c=" + category.id;
        }
      }
      return top_link;
    }
  }
};
</script>
<style scoped>
.msum-pageArticle__txt {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.historyPage .msum-pageArticle__link {
  margin-bottom: 20px;
}

@media only screen and (max-width: 767px) {
  .historyPage .msum-pageArticle__link {
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Product.vue